// DE — German. Translates en.js key for key (PM-0212).
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions. A
// key that ever goes missing falls back to English (translator.js), never to
// Persian.
//
// German typography is in the values themselves: formal Sie, „…“ quotes,
// no space before : ; ! ?, U+00A0 only between a figure and its unit or %.
// The one plural form is `<key>_one` (translator.js, Intl.PluralRules de:
// only 1 is `one`, so „0 Jahre“, „1 Jahr“). Brand and code values are kept as
// they are: 'Parsina', 'Parseh', 'PARSINA-1404-XXXX', the language endonyms.

export const de = {
  // ── app ──────────────────────────────────────────────────────────────────
  'app.title': 'Parsina – Modul Zahnmedizin',

  // ── nav / chrome ─────────────────────────────────────────────────────────
  'nav.brand.name': 'Parsina',
  'nav.brand.panel': 'Zahnmedizin',
  'nav.items.today': 'Heute',
  'nav.items.patients': 'Patienten',
  'nav.items.credits': 'Guthaben',
  'nav.items.profile': 'Profil',
  'nav.sidebar.collapse': 'Menü einklappen',
  'nav.sidebar.expand': 'Menü ausklappen',
  'nav.sidebar.logout': 'Abmelden',
  'nav.sidebar.editProfile': 'Profil',
  'nav.clinic.label': 'Praxis',
  'nav.account.menuLabel': 'Konto',
  'nav.account.parsina': 'Parsina-Konto',
  'nav.account.parsinaHint': 'Name, Passwort, Sprache',
  'nav.credits.label': 'Ihr Parseh-Guthaben',
  'nav.credits.topUp': 'Parseh aufladen',
  'nav.clinicSwitch.label': 'Zum Praxisbereich wechseln',
  'nav.landmark.primary': 'Hauptmenü',
  'nav.landmark.content': 'Inhalt',

  // ── common ───────────────────────────────────────────────────────────────
  'common.actions.cancel': 'Abbrechen',
  'common.actions.retry': 'Erneut versuchen',
  'common.loading': 'Wird geladen',
  'common.actions.save': 'Speichern',
  'common.actions.saving': 'Wird gespeichert…',
  'common.actions.back': 'Zurück',
  'common.actions.close': 'Schließen',
  'common.actions.clearFilters': 'Filter zurücksetzen',
  'common.actions.join': 'Beitreten',
  'common.state.pleaseWait': 'Bitte warten…',
  'common.labels.phone': 'Telefon',
  'common.labels.country': 'Land',
  'common.labels.nationalId': 'Nationale ID',
  'common.labels.fileNumber': 'Akten-Nr.',
  'common.labels.none': '—',
  'common.gender.male': 'Männlich',
  'common.gender.female': 'Weiblich',
  'common.marital.single': 'Ledig',
  'common.marital.married': 'Verheiratet',
  'common.marital.divorced': 'Geschieden',
  'common.marital.widowed': 'Verwitwet',
  'common.units.years': '{{count}} Jahre',
  'common.units.years_one': '{{count}} Jahr',
  'common.units.minute': 'Min.',
  'common.units.second': 'Sekunden',
  'common.units.toman': 'Toman',
  'common.units.tomans': 'Toman',
  'common.punct.colon': ':',
  'common.voice.start': 'Diktieren',
  'common.voice.stop': 'Aufnahme beenden',
  'common.voice.listening': 'Aufnahme läuft',
  'common.voice.priceTitle': '5 Parseh pro Aufnahmeminute, aufgerundet.',
  'common.voice.inlineTranscribing': 'Wird transkribiert…',
  'common.voice.error.denied': 'Der Mikrofonzugriff wurde verweigert',
  'common.voice.error.no-mic': 'Es wurde kein Mikrofon gefunden',
  'common.voice.error.unsupported': 'Dieser Browser kann keine Audioaufnahmen erstellen',
  'common.voice.error.insecure': 'Die Aufnahme funktioniert nur über eine sichere Verbindung (HTTPS)',
  'common.voice.error.credits': 'Ihr Parseh-Guthaben ist aufgebraucht',
  'common.voice.error.auth': 'Ihre Anmeldesitzung ist nicht mehr gültig. Bitte melden Sie sich erneut an',
  'common.voice.error.onboarding': 'Schließen Sie zuerst Ihre Registrierung ab',
  'common.voice.error.unavailable': 'Der Spracherkennungsdienst ist nicht verfügbar',
  'common.voice.error.timeout': 'Die Transkription hat zu lange gedauert',
  'common.voice.error.generic': 'Die Audioaufnahme ist fehlgeschlagen',

  // ── mobile shell ─────────────────────────────────────────────────────────
  'mobile.greeting': 'Willkommen,',
  'mobile.showMore': 'Mehr anzeigen',
  'mobile.close': 'Schließen',

  // ── auth / boot ──────────────────────────────────────────────────────────
  'auth.checking': 'Sie werden angemeldet…',
  'auth.loading': 'Ihr Arbeitsbereich wird geladen…',
  'auth.loopError': 'Die Anmeldung leitet immer wieder weiter. Löschen Sie Ihre Anmeldesitzung und versuchen Sie es erneut, oder kontaktieren Sie den Support.',
  'auth.loopTitle': 'Anmeldung fehlgeschlagen',
  'auth.checkingHint': 'Einen Moment bitte',
  'auth.stuck': 'Nicht weitergeleitet?',
  'auth.manualSignIn': 'Hier klicken',
  'auth.retry': 'Erneut versuchen',
  'auth.signOut': 'Abmelden',
  'auth.bootFailed.title': 'Start fehlgeschlagen',
  'auth.bootFailed.body': 'Ihr Arbeitsbereich konnte nicht geladen werden. Das ist meist nur vorübergehend.',
  'auth.session.expiringTitle': 'Ihre Anmeldesitzung läuft bald ab',
  'auth.session.expiringBody': 'Verlängern Sie sie, um ohne Unterbrechung weiterzuarbeiten.',
  'auth.session.staySignedIn': 'Weiterarbeiten',
  'auth.session.expiredTitle': 'Ihre Anmeldesitzung ist abgelaufen',
  'auth.session.expiredBody': 'Melden Sie sich erneut an, um fortzufahren. Diese Seite wurde nicht geschlossen – Sie kehren danach hierher zurück.',
  'auth.session.signInAgain': 'Erneut anmelden',
  'auth.session.returnNotice': 'Alles, was Sie bereits gespeichert haben, bleibt erhalten. Notieren Sie nicht gespeicherte Angaben auf dem Bildschirm, bevor Sie sich erneut anmelden.',

  // ── errors ───────────────────────────────────────────────────────────────
  'errors.generic': 'Es ist ein Fehler aufgetreten.',
  'errors.load.today': 'Der Tag konnte nicht geladen werden.',
  'errors.load.patients': 'Die Patientenliste konnte nicht geladen werden.',
  'errors.load.patient': 'Diese Akte konnte nicht geladen werden.',
  'errors.load.profile': 'Ihr Profil konnte nicht geladen werden.',
  'errors.load.drugs': 'Das Arzneimittelverzeichnis konnte nicht durchsucht werden.',
  'errors.credits.title': 'Nicht genug Parseh-Guthaben',
  'errors.credits.body': 'Die Wechselwirkungsprüfung benötigt Guthaben. Laden Sie es unter „Guthaben“ auf – das Verordnen selbst wird nicht blockiert.',

  // ── today (امروز) ─────────────────────────────────────────────────────────
  'today.title': 'Heute',
  'today.date.today': 'Heute',
  'today.date.prev': 'Vorheriger Tag',
  'today.date.next': 'Nächster Tag',
  'today.date.pick': 'Datum wählen',
  'today.counts.total': 'Termine',
  'today.counts.here': 'In der Praxis',
  'today.counts.scheduled': 'Geplant',
  'today.counts.completed': 'Behandelt',
  'today.counts.cancelled': 'Abgesagt',
  'today.counts.cancelledLine': 'Abgesagt: {{count}}',
  'today.notice.liveQueue': 'Das Live-Wartezimmer wird nur für heute angezeigt. Für andere Tage wird die Liste der geplanten Termine angezeigt.',
  'today.status.scheduled': 'Geplant',
  'today.status.arrived': 'Anwesend',
  'today.status.in_visit': 'In Behandlung',
  'today.status.completed': 'Behandelt',
  'today.status.cancelled': 'Abgesagt',
  'today.status.no_show': 'Nicht erschienen',
  'today.blocks.queue': 'Wartezimmer',
  'today.blocks.upcoming': 'Bevorstehend',
  'today.blocks.done': 'Abgeschlossen',
  'today.next.title': 'Nächster Patient',
  'today.next.at': 'um {{time}}',
  'today.next.service': 'Leistung: {{name}}',
  'today.next.serviceVisit': 'Sitzung',
  'today.next.serviceMore': '+{{count}} weitere',
  'today.empty.title': 'Für diesen Tag sind keine Termine geplant',
  'today.empty.description': 'Termine werden vom Empfang der Praxis vergeben und erscheinen hier automatisch.',
  'today.error.title': 'Der Tagesplan ist nicht verfügbar',
  'today.queue.positionNext': 'Als Nächstes',
  'today.queue.position': 'Nr. {{position}}',
  'today.queue.waited': '{{count}} Min. Wartezeit',
  'today.queue.waitedHours': '{{hours}} Std. Wartezeit',
  'today.queue.waitedHoursMinutes': '{{hours}} Std. {{minutes}} Min. Wartezeit',
  'today.queue.elapsed': '{{count}} Min. in Behandlung',
  'today.queue.elapsedHours': '{{hours}} Std. in Behandlung',
  'today.queue.elapsedHoursMinutes': '{{hours}} Std. {{minutes}} Min. in Behandlung',
  'today.row.visit': 'Sitzung',
  'today.row.visitFor': 'Sitzung von {{name}} öffnen',
  'today.row.open': 'Akte öffnen',
  'today.row.openFor': 'Akte von {{name}} öffnen',
  'today.row.walkIn': 'Schnelltermin',
  'today.row.unknownPatient': 'Patient ohne Namen',
  'today.readOnlyNote': 'Terminvergabe, Absagen und die Aufrufreihenfolge liegen beim Empfang der Praxis. Dieser Bereich zeigt dieselben Termine.',

  // ── patients (بیماران) ────────────────────────────────────────────────────
  'patients.title': 'Patienten',
  'patients.subtitle': 'Das Patientenregister der Praxis – dieselben Patienten, die der Empfang aufnimmt',
  'patients.search.placeholder': 'Name, Telefon, nationale ID oder Aktennummer',
  'patients.search.hint': 'Geben Sie mindestens zwei Zeichen ein, um zu suchen.',
  'patients.count': 'Patienten: {{count}}',
  'patients.columns.name': 'Patient',
  'patients.columns.phone': 'Telefon',
  'patients.columns.fileNumber': 'Akten-Nr.',
  'patients.columns.nationalId': 'Nationale ID',
  'patients.empty.title': 'Noch keine Patienten',
  'patients.empty.description': 'Patienten, die am Empfang der Praxis registriert werden, erscheinen hier.',
  'patients.emptyFiltered.title': 'Keine Treffer',
  'patients.emptyFiltered.description': 'Kein Patient entspricht dieser Suche.',
  'patients.noClinic.title': 'Sie gehören noch keiner Praxis an',
  'patients.noClinic.description': 'Das Patientenregister gehört zu einer Praxis. Treten Sie einer Praxis in Ihrem Profil mit deren Einladungscode bei.',
  'patients.noClinic.action': 'Zum Profil',
  'patients.pendingClinic.title': 'Ihre Zugehörigkeit wurde noch nicht bestätigt',
  'patients.pendingClinic.description': 'Sie haben den Beitritt beantragt. Die Praxis muss ihn bestätigen, bevor ihr Patientenregister für Sie freigegeben wird. Den Status finden Sie in Ihrem Profil.',
  'patients.error.title': 'Die Patientenliste ist nicht verfügbar',

  // ── patient workspace ────────────────────────────────────────────────────
  'patient.tabs.summary': 'Übersicht',
  'patient.tabs.history': 'Vorgeschichte',
  'patient.tabs.sectionsLabel': 'Abschnitte der Akte',
  'patient.actions.prescribe': 'Verordnen',
  'patient.notFound.title': 'Akte nicht gefunden',
  'patient.notFound.description': 'Dieser Patient existiert nicht oder ist für Sie nicht sichtbar.',
  'patient.error.title': 'Diese Akte ist nicht verfügbar',
  'patient.stats.age': 'Alter',
  'patient.stats.allergies': 'Allergien',
  'patient.stats.medications': 'Medikamente',
  'patient.summary.demographics': 'Angaben',
  'patient.summary.allergies': 'Allergien',
  'patient.summary.noAllergies': 'Keine Allergie erfasst.',
  'patient.severity.mild': 'Leicht',
  'patient.severity.moderate': 'Mittelgradig',
  'patient.severity.severe': 'Schwer',
  'patient.conditionStatus.active': 'Aktiv',
  'patient.conditionStatus.inactive': 'Inaktiv',
  'patient.conditionStatus.resolved': 'Abgeheilt',
  'patient.conditionStatus.remission': 'In Remission',
  'patient.photo.open': 'Foto von {{name}} vergrößert anzeigen',
  'patient.photo.alt': 'Profilfoto von {{name}}',
  'patient.summary.allergyWarning': 'Erfasste Allergien – vor dem Verordnen prüfen.',
  'patient.fields.birthDate': 'Geburtsdatum',
  'patient.fields.gender': 'Geschlecht',
  'patient.fields.maritalStatus': 'Familienstand',
  'patient.fields.bloodType': 'Blutgruppe',
  'patient.fields.job': 'Beruf',
  'patient.fields.insurance': 'Versicherung',
  'patient.fields.height': 'Größe',
  'patient.fields.createdAt': 'Registriert am',
  'patient.history.conditions': 'Diagnosen',
  'patient.history.medications': 'Medikamente',
  'patient.history.noConditions': 'Keine Diagnose erfasst.',
  'patient.history.noMedications': 'Kein Medikament erfasst.',
  'patient.history.prescribedOn': 'Verordnet am {{date}}',

  // ── prescription (نسخه) ──────────────────────────────────────────────────
  'prescription.title': 'Rezept',
  'prescription.subtitle': 'Für {{name}}',
  'prescription.search.label': 'Medikament hinzufügen',
  'prescription.search.placeholder': 'Medikament suchen…',
  'prescription.search.searching': 'Wird gesucht…',
  'prescription.search.empty': 'Kein passendes Medikament gefunden.',
  'prescription.search.hint': 'Geben Sie mindestens zwei Zeichen ein.',
  'prescription.search.results': 'Gefundene Medikamente: {{count}}.',
  'prescription.item.dose': 'Dosis',
  'prescription.item.frequency': 'Häufigkeit',
  'prescription.item.duration': 'Dauer',
  'prescription.item.note': 'Bemerkung',
  'prescription.item.remove': '{{name}} entfernen',
  'prescription.empty.title': 'Noch nichts verordnet',
  'prescription.empty.description': 'Suchen Sie oben ein Medikament, um das erste hinzuzufügen.',
  'prescription.save': 'Rezept speichern',
  'prescription.saveConfirm': 'Bestätigen und speichern',
  'prescription.saving': 'Wird gespeichert…',
  'prescription.saved': 'Rezept gespeichert.',
  'prescription.saveFailed': 'Das Rezept konnte nicht gespeichert werden.',
  'prescription.savePartial': 'Gespeicherte Medikamente: {{saved}} von {{total}}.',
  'prescription.allergies.title': 'Erfasste Allergien',
  'prescription.interactions.title': 'Wechselwirkungsprüfung',
  'prescription.interactions.checking': 'Wird geprüft…',
  'prescription.interactions.none': 'Keine Wechselwirkung zwischen diesen Medikamenten gefunden.',
  'prescription.interactions.needsTwo': 'Fügen Sie ein zweites Medikament hinzu, um die Wechselwirkungsprüfung zu starten.',
  'prescription.interactions.unavailable': 'Die Wechselwirkungsprüfung ist derzeit nicht verfügbar. Das Verordnen wird nicht blockiert.',
  'prescription.interactions.severity.high': 'Schwerwiegend',
  'prescription.interactions.severity.moderate': 'Mittelschwer',
  'prescription.interactions.severity.low': 'Geringfügig',
  'prescription.interactions.type.interaction': 'Wechselwirkung',
  'prescription.interactions.type.contraindication': 'Kontraindikation',
  'prescription.interactions.type.allergy': 'Allergie',
  'prescription.interactions.type.black_box': 'Schwerwiegender Warnhinweis',
  'prescription.history.title': 'Bisherige Medikation',
  'prescription.history.empty': 'Bisher nichts verordnet.',

  // ── profile ──────────────────────────────────────────────────────────────
  'profile.title': 'Profil',
  'profile.subtitle': 'Ihre Identität, Ihre Praxen und Ihre Anwesenheitszeiten',
  'profile.sections.label': 'Profilabschnitte',
  'profile.sections.identity': 'Identität',
  'profile.sections.clinics': 'Praxen',
  'profile.sections.presence': 'Anwesenheitszeiten',
  'profile.sections.appearance': 'Darstellung und Sprache',
  'profile.fields.fullName': 'Vollständiger Name',
  'profile.fields.medicalCode': 'Ärztekammernummer',
  'profile.fields.specialty': 'Fachrichtung',
  'profile.fields.bio': 'Über Sie',
  'profile.specialtyValue': 'Zahnmedizin',
  'profile.medicalCodeLocked': 'Die Ärztekammernummer wurde bei der Registrierung erfasst und kann nicht bearbeitet werden. Wenden Sie sich an den Parsina-Support, um sie korrigieren zu lassen.',
  'profile.specialtyLocked': 'Dieser Bereich ist für Zahnärzte bestimmt, daher ist die Fachrichtung festgelegt. Wird sie an anderer Stelle geändert, verliert Ihr Konto den Zugang zu diesem Bereich.',
  'profile.saved': 'Profil gespeichert.',
  'profile.noChanges': 'Keine Änderungen.',
  'profile.saveFailed': 'Das Profil konnte nicht gespeichert werden.',
  'profile.duplicateCode': 'Diese Ärztekammernummer gehört bereits zu einem anderen Konto.',
  'profile.clinics.empty': 'Sie gehören noch keiner Praxis an.',
  'profile.clinics.status.pending': 'Bestätigung der Praxis ausstehend',
  'profile.clinics.status.active': 'Aktiv',
  'profile.clinics.visitDuration': 'Zeitfenster {{count}} Min.',
  'profile.clinics.activeScope': 'Aktive Praxis',
  'profile.clinics.activeScopeHint': '„Heute“ und „Patienten“ zeigen diese Praxis.',
  'profile.clinics.joinTitle': 'Einer Praxis beitreten',
  'profile.clinics.joinHint': 'Fragen Sie die Praxisleitung nach dem Einladungscode.',
  'profile.clinics.joinPlaceholder': 'Einladungscode',
  'profile.clinics.joined': 'Sie sind {{name}} beigetreten.',
  'profile.clinics.notFound': 'Keine Praxis hat diesen Einladungscode.',
  'profile.clinics.joinFailed': 'Der Beitritt zur Praxis ist fehlgeschlagen.',
  'profile.presence.empty': 'Die Praxis hat für Sie noch keine Anwesenheitszeiten festgelegt.',
  'profile.presence.oneOff': 'Einmalig',
  'profile.presence.inactive': 'Inaktiv',
  'profile.presence.readOnly': 'Die Anwesenheitszeiten legt die Praxis fest; dieser Bereich zeigt sie nur an.',
  'profile.presence.days.0': 'Montag',
  'profile.presence.days.1': 'Dienstag',
  'profile.presence.days.2': 'Mittwoch',
  'profile.presence.days.3': 'Donnerstag',
  'profile.presence.days.4': 'Freitag',
  'profile.presence.days.5': 'Samstag',
  'profile.presence.days.6': 'Sonntag',
  'profile.appearance.theme': 'Akzentfarbe',
  'profile.appearance.fontSize': 'Textgröße',
  'profile.appearance.language': 'Sprache',
  'profile.appearance.saved': 'Einstellung gespeichert.',
  'profile.appearance.failed': 'Die Einstellung wurde nicht auf dem Server gespeichert.',
  'profile.theme.default': 'Parsina-Blau',
  'profile.theme.teal': 'Türkis',
  'profile.theme.ocean': 'Tiefblau',
  'profile.theme.slate': 'Blaugrau',
  'profile.fontSize.small': 'Klein',
  'profile.fontSize.medium': 'Mittel',
  'profile.fontSize.large': 'Groß',
  'profile.language.fa': 'فارسی',
  'profile.language.en': 'English',
  'profile.language.fr': 'Français',
  'profile.language.de': 'Deutsch',

  // ── onboarding ───────────────────────────────────────────────────────────
  'onboarding.title': 'Parsina-Modul Zahnmedizin',
  'onboarding.subtitle.step1': 'Registrieren Sie sich einmalig, damit Ihr Konto identifiziert werden kann',
  'onboarding.subtitle.clinic': 'Verbinden Sie sich mit der Praxis, in der Sie arbeiten',
  'onboarding.subtitle.done': 'Alles bereit',
  'onboarding.progress.step1': 'Registrierung',
  'onboarding.progress.clinic': 'Praxis',
  'onboarding.progress.done': 'Fertig',
  'onboarding.step1.fullName': 'Vollständiger Name',
  'onboarding.step1.fullNamePlaceholder': 'Dr. Maryam Ahmadi',
  'onboarding.step1.medicalCode': 'Ärztekammernummer',
  'onboarding.step1.medicalCodePlaceholder': 'z. B. 123456',
  'onboarding.step1.specialty': 'Fachrichtung',
  'onboarding.step1.bio': 'Über Sie (optional)',
  'onboarding.step1.submit': 'Weiter',
  'onboarding.step1.specialtyNote': 'Dieser Bereich ist das Modul Zahnmedizin, daher ist die Fachrichtung für Sie festgelegt.',
  'onboarding.clinic.choiceTitle': 'Ihre Einzelpraxis oder Praxis',
  'onboarding.clinic.choiceDescription': 'Wenn Sie eine eigene Einzelpraxis haben, registrieren Sie sie hier. Wenn Sie in einer anderen Praxis arbeiten, treten Sie ihr mit einem Einladungscode bei.',
  'onboarding.clinic.ownTitle': 'Eigene Einzelpraxis registrieren',
  'onboarding.clinic.ownBody': 'Für eine eigene Praxis. Sie werden ihr Inhaber.',
  'onboarding.clinic.joinTitle': 'Einer bestehenden Praxis beitreten',
  'onboarding.clinic.joinBody': 'Mit dem Einladungscode, den Sie von der Praxis erhalten haben.',
  'onboarding.clinic.back': 'Zurück',
  'onboarding.clinic.ownName': 'Name der Praxis',
  'onboarding.clinic.ownNamePlaceholder': 'Zahnarztpraxis Dr. Ahmadi',
  'onboarding.clinic.ownCity': 'Stadt (optional)',
  'onboarding.clinic.ownAddress': 'Adresse (optional)',
  'onboarding.clinic.ownPhone': 'Telefon der Praxis (optional)',
  'onboarding.clinic.create': 'Praxis registrieren',
  'validation.clinicName': 'Geben Sie den Namen der Praxis ein.',
  'onboarding.clinic.alreadyExists': 'Für dieses Konto ist bereits eine Praxis registriert.',
  'onboarding.clinic.currency': 'Währung der Praxis',
  'onboarding.clinic.currencyHint': 'Gebühren und Behandlungspläne werden in dieser Währung erfasst. Im Praxisbereich lässt sie sich nur ändern, bis der erste Betrag erfasst ist.',
  'onboarding.clinic.currencyIrr': 'Toman (IRR)',
  'onboarding.clinic.currencyMismatch': 'Für dieses Konto ist bereits eine Praxis mit der Währung {{currency}} registriert. Wählen Sie diese Währung oder ändern Sie sie im Praxisbereich.',
  'onboarding.clinic.setupIncomplete': 'Die Praxis wurde angelegt, aber ihre Währung konnte in der Buchhaltung nicht festgelegt werden. Registrieren Sie sie nicht erneut – wenden Sie sich an den Parsina-Support, um die Einrichtung abzuschließen.',
  'onboarding.clinic.title': 'Ihrer Praxis beitreten',
  'onboarding.clinic.description': 'Mit dem Einladungscode der Praxis werden Ihre Termine und das Patientenregister der Praxis freigegeben. Sie können dies auch später in Ihrem Profil erledigen.',
  'onboarding.clinic.placeholder': 'Einladungscode',
  'onboarding.clinic.join': 'Beitreten',
  'onboarding.clinic.skip': 'Später',
  'onboarding.done.title': 'Willkommen',
  'onboarding.done.body': 'Ihr zahnmedizinischer Arbeitsbereich ist bereit. „Heute“ zeigt die Termine, die die Praxis für Sie vergibt.',
  'onboarding.done.enter': 'Bereich öffnen',

  // ── validation ───────────────────────────────────────────────────────────
  'validation.medicalCode': 'Geben Sie Ihre Ärztekammernummer ein.',
  'validation.fullName': 'Geben Sie Ihren vollständigen Namen ein.',
  'validation.invitationCode': 'Geben Sie den Einladungscode ein.',
  'validation.officePhone': 'Die Telefonnummer der Praxis ist unvollständig. Korrigieren Sie sie oder leeren Sie das Feld.',
  'validation.phone.tooShort': 'Diese Nummer ({{country}}) ist zu kurz – Beispiel: {{example}}',
  'validation.phone.tooLong': 'Diese Nummer ({{country}}) ist zu lang – Beispiel: {{example}}',
  'validation.phone.invalid': 'Diese Nummer ist ungültig.',

  // ── چارت دندان / odontogram ──────────────────────────────────────────────
  'patient.tabs.plan': 'Behandlungsplan',
  'patient.plan.empty.title': 'Für diesen Patienten wurde noch kein Behandlungsplan erfasst',
  'patient.plan.empty.description': 'Ein Behandlungsplan wird während einer Sitzung erstellt.',
  'patient.plan.noLines': 'Dieser Behandlungszyklus enthält noch keine Positionen.',
  'patient.plan.doneTitle': 'Durchgeführte Behandlungen',
  'patient.plan.outstanding': 'Offene Maßnahmen: {{count}} – insgesamt {{amount}}',
  'patient.tabs.chart': 'Zahnschema',
  'chart.tooth': 'Zahn',
  'chart.universalShort': 'US-Nr.',
  'chart.annotation.planned': 'geplant',
  'chart.annotation.treated': 'behandelt',
  'chart.legend.planned': 'Geplant',
  'chart.legend.treated': 'Behandelt',
  'chart.tooltip.treated': 'Durchgeführte Behandlungen',
  'chart.tooltip.andMore': 'und weitere ({{count}})',
  'chart.tooltip.planned': 'Geplant',
  'chart.wholeMouth.title': 'Gesamtgebiss',
  'chart.history.title': 'Verlauf von Zahn {{fdi}}',
  'chart.history.treatment': 'Behandlung',
  'chart.history.event': 'Zahnschema',
  'chart.history.causedBy': 'aus der Behandlung oben',
  'chart.history.empty': 'Für diesen Zahn wurde noch nichts erfasst.',
  'chart.history.unavailable': 'Der Verlauf dieses Zahns konnte nicht gelesen werden.',
  'chart.history.session': 'Sitzung {{n}}',
  'chart.history.voided': 'Storniert – {{reason}}',
  'chart.notCharted': 'Nicht erfasst',
  'chart.patientRight': 'RECHTS (PATIENT)',
  'chart.patientLeft': 'LINKS (PATIENT)',
  'chart.aria.odontogram': 'Zahnschema – klicken Sie auf einen Zahn oder eine Fläche, um einen Befund zu erfassen',
  'chart.hint': 'Klicken Sie auf eine Fläche, um sie zu erfassen, oder auf den Zahn für seinen Gesamtstatus.',

  // ── chart, mobile ────────────────────────────────────────────────────────
  'chart.mobile.settings': 'Einstellungen des Zahnschemas',
  'chart.mobile.pickTooth': 'Zahn auswählen',
  'chart.mobile.tapHint': 'Tippen Sie im Zahnschema auf einen Zahn oder wählen Sie unten einen aus – die Flächen werden im sich öffnenden Fenster erfasst.',
  'chart.mobile.legend': 'Legende',
  'chart.legend.bridge': 'Brücke',
  'chart.legend.wholeToothCaries': 'Karies des gesamten Zahns',
  'chart.export.button': 'Bild exportieren',
  'chart.export.error': 'Das Bild konnte nicht exportiert werden – dieser Browser unterstützt das nicht.',
  'chart.material': 'Material',
  'chart.isHistorical': 'Vorhandene Versorgung (nicht heute durchgeführt)',
  'chart.showPrimary': 'Milchzähne anzeigen',
  'chart.hidePrimary': 'Milchzähne ausblenden',
  'chart.showUniversal': 'US-Nummern anzeigen',
  'chart.hideUniversal': 'US-Nummern ausblenden',
  'chart.error.title': 'Das Zahnschema konnte nicht geladen werden',
  'chart.error.body': 'Das Zahnschema konnte nicht abgerufen werden. Bitte versuchen Sie es erneut.',
  'chart.summary.charted': 'Erfasst',
  'chart.summary.decayed': 'Kariös',
  'chart.summary.restored': 'Gefüllt',
  'chart.summary.missing': 'Fehlend',
  'chart.summary.dmft': 'DMF-T',
  'chart.presence.title': 'Vorhandensein',
  'chart.presence.present': 'Vorhanden',
  'chart.presence.extracted': 'Extrahiert',
  'chart.presence.exfoliated': 'Ausgefallen',
  'chart.presence.congenitally_absent': 'Nicht angelegt',
  'chart.presence.unerupted': 'Nicht durchgebrochen',
  'chart.presence.impacted': 'Retiniert',
  'chart.surfaces.title': 'Flächen',
  'chart.surfaces.hint': 'Fläche wählen, dann ihren Status',
  'chart.surfaces.setFor': 'Status für',
  'chart.surface.M': 'Mesial',
  'chart.surface.D': 'Distal',
  'chart.surface.F': 'Vestibulär',
  'chart.surface.L': 'Oral',
  'chart.surface.O': 'Okklusal',
  'chart.surface.I': 'Inzisal',
  'chart.surfaceState.sound': 'Gesund',
  'chart.surfaceState.caries': 'Karies',
  'chart.surfaceState.restoration': 'Füllung',
  'chart.surfaceState.recurrent_caries': 'Sekundärkaries',
  'chart.surfaceState.temporary': 'Provisorium',
  'chart.surfaceState.sealant': 'Fissurenversiegelung',
  'chart.surfaceState.fractured': 'Frakturiert',
  'chart.condition.title': 'Gesamter Zahn',
  'chart.condition.hint': 'Unabhängig von den Flächen oben',
  'chart.conditionName.sound': 'Gesund',
  'chart.conditionName.caries': 'Karies',
  'chart.conditionName.root_canal': 'Wurzelgefüllt',
  'chart.conditionName.post_core': 'Stiftaufbau',
  'chart.conditionName.crown': 'Krone',
  'chart.conditionName.veneer': 'Veneer',
  'chart.conditionName.implant': 'Implantat',
  'chart.conditionName.bridge_abutment': 'Brückenpfeiler',
  'chart.conditionName.bridge_pontic': 'Brückenglied',
  'chart.conditionName.fracture': 'Fraktur',
  'chart.conditionName.attrition': 'Attrition',
  'chart.conditionName.mobility': 'Zahnlockerung',
  'chart.conditionName.periapical_lesion': 'Apikale Läsion',
  'chart.conditionName.sealant': 'Fissurenversiegelung',
  'chart.conditionName.temporary': 'Provisorium',
  'chart.conditionName.watch': 'Zu beobachten',
  'chart.note.title': 'Notiz',
  'chart.note.placeholder': 'Alles, was zu diesem Zahn festgehalten werden sollte',
  'chart.materialName.composite': 'Komposit',
  'chart.materialName.amalgam': 'Amalgam',
  'chart.materialName.glass_ionomer': 'Glasionomerzement',
  'chart.materialName.zirconia': 'Zirkonoxid',
  'chart.materialName.pfm': 'VMK',
  'chart.materialName.full_metal': 'Vollguss (NEM)',
  'chart.materialName.emax': 'E.max',
  'chart.materialName.temporary': 'Provisorisch',
  'chart.materialName.gold': 'Gold',

  // ── hover card ──────────────────────────────────────────────────────────
  'chart.primary': 'Milchzahn',
  'chart.tooltip.notCharted': 'Für diesen Zahn wurde noch nichts erfasst.',
  'chart.tooltip.sound': 'Untersucht – ohne Befund',
  'chart.tooltip.lastRecorded': 'Zuletzt erfasst',
  'chart.quadrant.upperRight': 'Oberkiefer rechts (Patient)',
  'chart.quadrant.upperLeft': 'Oberkiefer links (Patient)',
  'chart.quadrant.lowerRight': 'Unterkiefer rechts (Patient)',
  'chart.quadrant.lowerLeft': 'Unterkiefer links (Patient)',
  'chart.toothName.centralIncisor': 'Mittlerer Schneidezahn',
  'chart.toothName.lateralIncisor': 'Seitlicher Schneidezahn',
  'chart.toothName.canine': 'Eckzahn',
  'chart.toothName.firstPremolar': 'Erster Prämolar',
  'chart.toothName.secondPremolar': 'Zweiter Prämolar',
  'chart.toothName.firstMolar': 'Erster Molar',
  'chart.toothName.secondMolar': 'Zweiter Molar',
  'chart.toothName.thirdMolar': 'Dritter Molar (Weisheitszahn)',

  // ── جلسهٔ درمان — the visit workspace (docs/dent-visit.md) ────────────────
  'visit.error.title': 'Die Sitzung konnte nicht geöffnet werden',
  'visit.error.body': 'Dieser Termin konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.notFound.title': 'Sitzung nicht gefunden',
  'visit.notFound.description': 'Dieser Termin existiert nicht, gehört nicht zu Ihnen oder ist mit keiner Patientenakte verknüpft.',
  'visit.unknownPatient': 'Patient ohne Namen',
  'visit.openRecord': 'Patientenakte',
  'visit.finish.action': 'Sitzung beenden',
  'visit.finish.working': 'Wird beendet…',
  'visit.finish.confirm.title': 'Diese Sitzung beenden?',
  'visit.finish.confirm.body': 'Alles noch nicht Gespeicherte wird gespeichert und die Sitzung beendet. Danach ist sie schreibgeschützt und kann in dieser App nicht wieder geöffnet werden.',
  'visit.finish.followUp.title': 'Verbleibende Maßnahmen im Plan: {{count}}',
  'visit.finish.followUp.andMore': 'und weitere ({{count}})',
  'visit.finish.followUp.today': 'Heute',
  'visit.finish.followUp.tomorrow': 'Morgen',
  'visit.finish.followUp.withinWeek': 'Innerhalb einer Woche',
  'visit.finish.followUp.within2Weeks': 'Innerhalb von zwei Wochen',
  'visit.finish.followUp.withinMonth': 'Innerhalb eines Monats',
  'visit.finish.followUp.within3Months': 'Innerhalb von drei Monaten',
  'visit.finish.followUp.when': 'Bis wann sollte der nächste Termin stattfinden?',
  'visit.finish.followUp.none': 'Nicht erforderlich',
  'visit.finish.followUp.deskNote': 'Der Empfang wird informiert, damit er den Termin bei Ihnen vergeben kann.',
  'visit.finish.followUp.noneNote': 'Der Empfang wird nicht informiert.',
  'visit.finish.done.plain': 'Die Sitzung ist beendet.',
  'visit.finish.done.followUpRaised': 'Die Sitzung ist beendet. Der Empfang wurde gebeten, den nächsten Termin zu vergeben.',
  'visit.finish.done.alreadyBooked': 'Die Sitzung ist beendet. Dieser Patient hat bereits einen nächsten Termin.',
  'visit.finish.done.followUpFailed': 'Die Sitzung ist beendet, aber der Empfang wurde nicht über den nächsten Termin informiert.',
  'visit.finish.error.subjective': 'Die Anamnese wurde nicht gespeichert, daher wurde die Sitzung nicht beendet. Versuchen Sie es erneut.',
  'visit.finish.error.complete': 'Die Anamnese wurde gespeichert, aber die Sitzung konnte nicht beendet werden. Versuchen Sie es erneut.',

  // ── The video visit ──────────────────────────────────────────────────────
  'visit.call.start': 'Videoanruf',
  'visit.call.title': 'Videoanruf',
  'visit.call.panelLabel': 'Videoanruf-Fenster',
  'visit.call.connecting': 'Verbindung wird hergestellt…',
  'visit.call.hangUp': 'Anruf beenden',
  'visit.call.notRecorded': 'Dieser Anruf wird nicht aufgezeichnet, und nichts davon wird gespeichert.',
  'visit.call.error.connection': 'Der Anruf konnte nicht verbunden werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
  'visit.call.error.unavailable': 'Videosprechstunden sind in dieser Umgebung nicht aktiviert.',
  'visit.call.error.visitOver': 'Diese Sitzung ist beendet, daher kann kein Videoanruf dazu gestartet werden.',
  'visit.readOnly.badge': 'Nur Lesen',
  'visit.readOnly.note': 'Diese Sitzung ist beendet, daher kann nichts mehr dazu erfasst werden. Alles bereits Erfasste wird weiterhin angezeigt.',
  'visit.ai.costsCredits': 'Verbraucht Parseh-Guthaben.',
  'visit.tabs.meds': 'Medikation',
  'visit.tabs.orders': 'Anordnungen',
  'visit.tabs.diagnosis': 'Diagnose',
  'visit.tabs.questions': 'Fragen',
  'visit.tabs.files': 'Dateien',
  'visit.tabs.sectionsLabel': 'Abschnitte der Sitzung',

  // ── §3.1.1 odontogram ───────────────────────────────────────────────────
  'visit.chart.title': 'Zahnschema',
  'visit.chart.hint': 'Wählen Sie einen Zahn, um seine Befunde und die geplanten Maßnahmen zu sehen.',
  'visit.chart.tooth': 'Zahn {{fdi}}',
  'visit.chart.openTooth': 'Befunde',
  'visit.chart.planForTooth': 'Zum Plan hinzufügen',
  'visit.chart.noPlanForTooth': 'Für diesen Zahn ist nichts geplant.',
  'visit.chart.history': 'Verlauf',
  'visit.chart.noHistory': 'Für diesen Zahn wurde nichts erfasst.',
  'visit.chart.historyUnavailable': 'Der Verlauf konnte nicht geladen werden.',
  'visit.chart.historical': 'vorbestehend',

  // ── §3.1.2 subjective ───────────────────────────────────────────────────
  'visit.subjective.title': 'Anamnese',
  'visit.subjective.error.title': 'Die Anamnese konnte nicht geladen werden',
  'visit.subjective.error.body': 'Die Anamnese dieser Sitzung konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.subjective.saved': 'Gespeichert',
  'visit.subjective.saveFailed': 'Die Anamnese konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  'visit.subjective.history': 'Vorgeschichte des Patienten',
  'visit.subjective.noAllergies': 'Keine Allergien erfasst',
  'visit.subjective.conditions': 'Erkrankungen',
  'visit.subjective.medications': 'Medikation',
  'visit.subjective.chiefComplaint': 'Vorstellungsgrund',
  'visit.subjective.dictateComplaint': 'Vorstellungsgrund diktieren',
  'visit.subjective.dictateNotes': 'Notiz diktieren',
  'visit.subjective.teeth': 'Betroffene Zähne',
  'visit.subjective.noTeeth': 'Tippen Sie oben im Zahnschema auf die betroffenen Zähne',
  'visit.subjective.addTooth': 'Zahn {{fdi}} hinzufügen',
  'visit.subjective.selectToothFirst': 'Wählen Sie im Zahnschema einen Zahn aus',
  'visit.subjective.painScore': 'Schmerzstärke (0–10)',
  'visit.subjective.painCharacter': 'Schmerzcharakter',
  'visit.subjective.pain.sharp': 'Stechend',
  'visit.subjective.pain.dull': 'Dumpf',
  'visit.subjective.pain.throbbing': 'Pochend',
  'visit.subjective.pain.sensitivity': 'Empfindlichkeit',
  'visit.subjective.pain.none': 'Keine Schmerzen',
  'visit.subjective.onset': 'Beschwerdebeginn',
  'visit.subjective.duration': 'Dauer',
  'visit.subjective.aggravating': 'Verstärkt durch',
  'visit.subjective.relieving': 'Gelindert durch',
  'visit.subjective.dentalHistory': 'Zahnärztliche Vorgeschichte',
  'visit.subjective.notes': 'Notizen',
  'visit.subjective.priorVisits': 'Frühere Sitzungen',
  'visit.subjective.noPriorVisits': 'Keine früheren Sitzungen erfasst.',
  'visit.subjective.priorNoSummary': 'Kein Vorstellungsgrund erfasst',
  'visit.subjective.priorDiagnoses': 'Diagnosen: {{count}}',

  // ── §3.1.3 treatment plan ───────────────────────────────────────────────
  'visit.plan.title': 'Behandlungsplan',
  'visit.plan.error.title': 'Der Plan konnte nicht geladen werden',
  'visit.plan.error.body': 'Der Behandlungsplan dieses Patienten konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.plan.error.currencyUnavailable': 'Die Währung der Praxis konnte nicht gelesen werden; ohne sie können die Beträge des Plans nicht angezeigt werden. Bitte versuchen Sie es erneut.',
  'visit.plan.error.currencyMismatch': 'Diese Beträge sind nicht in der Währung der Praxis, und Beträge in unterschiedlichen Währungen werden nie zusammengerechnet. Bitten Sie die Praxisleitung, die Währung der Praxis zu prüfen.',
  'visit.plan.saveFailed': 'Der Plan konnte nicht gespeichert werden.',
  'visit.plan.empty.title': 'Noch kein Plan',
  'visit.plan.empty.description': 'Fügen Sie die geplanten Maßnahmen Zahn für Zahn hinzu.',
  'visit.plan.add': 'Maßnahme hinzufügen',
  'visit.plan.added': '„{{what}}“ wurde zum Behandlungsplan hinzugefügt.',
  'visit.plan.addedForTooth': '„{{what}}“ wurde für Zahn {{fdi}} zum Behandlungsplan hinzugefügt.',
  'visit.chart.planFormOpened': 'Formular für Zahn {{fdi}} geöffnet – wählen Sie die Maßnahme.',
  'visit.plan.addItem': 'Zum Plan hinzufügen',
  'visit.plan.service': 'Maßnahme',
  'visit.plan.choose': 'Maßnahme auswählen…',
  'visit.plan.tooth': 'Zahn',
  'visit.plan.wholeMouth': 'Gesamtgebiss',
  'visit.plan.wholeMouthShort': 'Gebiss',
  'visit.plan.phase': 'Phase',
  'visit.plan.description': 'Beschreibung',
  'visit.plan.untitledItem': 'Maßnahme ohne Titel',
  'visit.plan.changeStatus': 'Status ändern: {{item}}',
  'visit.plan.remove': '{{item}} entfernen',
  'visit.plan.showOnChart': 'Im Zahnschema anzeigen',
  'visit.plan.surfaces': 'Flächen',
  'visit.plan.sessions': 'Sitzungen',
  'visit.plan.sessionsOf': 'Sitzung {{done}} von {{total}}',
  'visit.plan.toman': '{{amount}} {{unit}}',
  'visit.plan.noTariff': 'Keine Gebühr festgelegt',
  'visit.plan.outstanding': 'Offen: {{amount}}',
  'visit.plan.otherCurrency': 'Gebühr in anderer Währung ({{currency}})',
  'visit.plan.otherCurrencyRefused': 'Die Gebühr für „{{name}}“ ist in {{currency}} angegeben und kann daher keinem Plan in {{planCurrency}} hinzugefügt werden.',
  'visit.record.openVisit': 'Sitzung öffnen',
  'visit.record.open': 'Als durchgeführt erfassen',
  'visit.record.openSession': 'Sitzung erfassen',
  'visit.record.title': 'Als durchgeführt erfassen – {{treatment}}',
  'visit.record.subtitle': 'Erfasst, was in dieser Sitzung durchgeführt wurde. Dies ist die klinische Dokumentation.',
  'visit.record.service': 'Durchgeführte Behandlung',
  'visit.record.tooth': 'Zahn',
  'visit.record.surfaces': 'Flächen',
  'visit.record.material': 'Material',
  'visit.record.noMaterial': 'Kein Material',
  'visit.record.note': 'Durchgeführte Maßnahme',
  'visit.record.notePlaceholder': 'Kurz beschreiben, was durchgeführt wurde',
  'visit.record.outcome': 'Ergebnis',
  'visit.record.outcome.completed': 'Abgeschlossen',
  'visit.record.outcome.inProgress': 'Fortsetzung in der nächsten Sitzung',
  'visit.record.chartEffect': 'Zahnstatus nach der Behandlung',
  'visit.record.chartEffect.none': 'Zahnschema unverändert lassen',
  'visit.record.chartEffect.noneDetail': 'Im Zahnschema wird nichts eingetragen.',
  'visit.record.chartEffect.detail': 'Zahn {{tooth}} wird im Zahnschema als „{{state}}“ eingetragen.',
  'visit.record.chartEffect.detailSurfaces': 'Die Flächen {{surfaces}} von Zahn {{tooth}} werden im Zahnschema als „{{state}}“ eingetragen.',
  'visit.record.chartEffect.needsSurfaces': 'Wählen Sie die behandelten Flächen aus, sonst wird nichts im Zahnschema eingetragen.',
  'visit.record.chartEffect.surfaceOption': 'Flächen – {{state}}',
  'visit.record.chartEffect.inProgress': 'Diese Sitzung schließt die Behandlung nicht ab, daher wird standardmäßig nichts im Zahnschema eingetragen.',
  'visit.record.billingNote': 'Abrechnung und Lagerentnahme werden nach diesem Eintrag getrennt erfasst; dieses Formular erfasst keinen Betrag.',
  'visit.record.save': 'Erfassen',
  'visit.record.saved': '„{{what}}“ wurde erfasst.',
  'visit.record.failed': 'Die Behandlung konnte nicht erfasst werden.',
  'visit.record.doneHere': 'In dieser Sitzung durchgeführt ({{count}})',
  'visit.record.void': 'Stornieren',
  'visit.record.voidReason': 'Stornogrund',
  'visit.record.voidedFor': 'Storniert – {{reason}}',
  'visit.record.voidConfirm.title': '„{{what}}“ stornieren?',
  'visit.record.voidConfirm.body': 'Der Eintrag wird nicht gelöscht: Er bleibt durchgestrichen und mit dem von Ihnen angegebenen Grund in der Akte. Ein Grund ist erforderlich.',
  'visit.record.notBilled': 'Nicht abgerechnet',
  'visit.record.voidConfirm.alsoChart': 'Auch den Eintrag für Zahn {{tooth}} im Zahnschema stornieren',
  'visit.record.voidConfirm.stillBilled': 'Diese Behandlung ist bereits auf der Rechnung des Patienten berechnet. Beim Stornieren wird der Betrag automatisch zurückgenommen – als negative Korrekturposition, falls die Rechnung bereits ausgestellt wurde.',
  'visit.record.voidCharge.notReversed': 'Die Behandlung wurde storniert, der Betrag konnte jedoch nicht von der Rechnung genommen werden. Bitten Sie die Kasse, dies zu korrigieren.',
  'visit.record.billed': 'Zur Rechnung dieser Sitzung hinzugefügt.',
  'visit.plan.noServices.title': 'Diese Praxis hat noch keine Leistungen definiert',
  'visit.plan.noServices.body': 'Die Positionen des Behandlungsplans stammen aus den Leistungen der Praxis. Definieren Sie die zahnärztlichen Leistungen im Praxisbereich und legen Sie ihre Gebühren fest.',
  'visit.plan.noServices.action': 'Leistungen im Praxisbereich definieren',
  'visit.plan.catalogUnavailable': 'Die Leistungsliste der Praxis konnte nicht gelesen werden. Das bedeutet nicht, dass keine vorhanden sind – versuchen Sie es erneut.',
  'visit.plan.applicability.unset': 'Nicht angegeben',
  'visit.plan.applicability.tooth': 'Ein Zahn',
  'visit.plan.applicability.surfaces': 'Flächen eines Zahns',
  'visit.plan.applicability.quadrant': 'Ein Quadrant',
  'visit.plan.applicability.arch': 'Ein Kiefer',
  'visit.plan.applicability.mouth': 'Gesamtgebiss',
  'visit.plan.newService.title': 'Neue Leistung',
  'visit.plan.newService.subtitle': 'Wird zu den Leistungen der Praxis hinzugefügt und steht ab dann dem gesamten Team zur Auswahl.',
  'visit.plan.newService.name': 'Name der Leistung',
  'visit.plan.newService.category': 'Gruppe',
  'visit.plan.newService.chartEffect': 'Auswirkung auf das Zahnschema',
  'visit.plan.newService.applicability': 'Gilt für',
  'visit.plan.newService.tariff': 'Gebühr pro Sitzung ({{unit}})',
  'visit.plan.newService.duration': 'Minuten pro Sitzung',
  'visit.plan.newService.tariffHint': 'Die Gebühr kann leer bleiben; die Leistung wird ohne Gebühr gespeichert und erst abgerechnet, wenn eine festgelegt ist.',
  'visit.plan.newService.clinicOnly.title': 'Wird im Praxisbereich vervollständigt',
  'visit.plan.newService.clinicOnly.body': 'Verbrauchsmaterial, sonstige Kosten, Anteil und Versicherung.',
  'visit.plan.newService.save': 'Speichern und auswählen',
  'visit.plan.newService.created': '„{{name}}“ wurde zu den Leistungen der Praxis hinzugefügt.',
  'visit.plan.newService.nameRequired': 'Der Name der Leistung ist erforderlich.',
  'visit.plan.newService.failed': 'Die Leistung konnte nicht gespeichert werden.',
  'visit.plan.newService.badTariff': 'Die Gebühr muss eine Zahl in {{unit}} sein.',
  'visit.plan.newService.currencyUnknown': 'Die Währung dieser Praxis konnte nicht gelesen werden, daher kann die Gebühr hier nicht eingegeben werden. Die Leistung wird ohne Gebühr gespeichert; legen Sie die Gebühr im Praxisbereich fest.',
  'visit.plan.noClinic': 'Diese Sitzung ist keiner Praxis zugeordnet; ohne Praxis können Leistungen und Gebühren nicht gelesen werden.',
  'common.form.optional': '(optional)',
  'visit.plan.locked': 'Unterschrieben',
  'visit.plan.startNew': 'Neuen Behandlungszyklus beginnen',
  'visit.plan.lockedNextStep': 'Wenn Sie eine Maßnahme hinzufügen, beginnt ein neuer Behandlungszyklus.',
  'visit.plan.lockedNote': 'Dieser Plan wurde genehmigt und unterschrieben, daher können seine Positionen nicht mehr geändert werden. Maßnahmen können weiterhin als durchgeführt markiert werden.',
  'visit.plan.phases.emergency': 'Akutbehandlung',
  'visit.plan.phases.phase1': 'Phase 1',
  'visit.plan.phases.phase2': 'Phase 2',
  'visit.plan.phases.maintenance': 'Erhaltungsphase',
  'visit.plan.status.proposed': 'Vorgeschlagen',
  'visit.plan.status.accepted': 'Angenommen',
  'visit.plan.status.done': 'Durchgeführt',
  'visit.plan.status.rejected': 'Abgelehnt',
  'visit.plan.status.deferred': 'Zurückgestellt',
  'visit.plan.planStatus.draft': 'Entwurf',
  'visit.plan.planStatus.proposed': 'Vorgeschlagen',
  'visit.plan.planStatus.approved': 'Genehmigt',
  'visit.plan.planStatus.in_progress': 'In Bearbeitung',
  'visit.plan.planStatus.completed': 'Abgeschlossen',
  'visit.plan.planStatus.abandoned': 'Abgebrochen',

  // ── §3.2.1 medication ───────────────────────────────────────────────────
  'visit.meds.empty.title': 'Noch nichts verordnet',
  'visit.meds.empty.description': 'Suchen Sie oben im Arzneimittelverzeichnis, um dieser Sitzung ein Medikament hinzuzufügen.',
  'visit.meds.thisVisit': 'In dieser Sitzung verordnet',
  'visit.meds.current': 'Aktuelle Medikation',
  'visit.meds.suggest': 'KI-Vorschläge',
  'visit.meds.suggesting': 'Wird analysiert…',
  'visit.meds.suggestions': 'Vorgeschlagene Medikamente',
  'visit.meds.suggestClose': 'Vorschläge ausblenden',
  'visit.meds.suggestAdd': 'Zum Rezept hinzufügen',
  'visit.meds.suggestAdded': 'Hinzugefügt',
  'visit.meds.noSuggestions': 'Keine Vorschläge. Erfassen Sie zuerst die Diagnose oder Beurteilung dieser Sitzung – die Analyse stützt sich auf das, was für diese Sitzung dokumentiert wurde.',
  'visit.meds.suggestUnavailable': 'KI-Vorschläge sind nicht verfügbar.',
  'visit.meds.followUp': 'Wiedervorstellung:',

  // ── §3.2.2 orders — dental lab and imaging only ─────────────────────────
  'visit.orders.error.title': 'Anordnungen konnten nicht geladen werden',
  'visit.orders.error.body': 'Die Anordnungen dieser Sitzung konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.orders.saveFailed': 'Die Anordnung konnte nicht gespeichert werden.',
  'visit.orders.empty.title': 'Keine Anordnungen in dieser Sitzung',
  'visit.orders.empty.description': 'Fordern Sie eine Röntgenaufnahme an oder senden Sie einen Fall an das Dentallabor.',
  'visit.orders.type': 'Art der Anordnung',
  'visit.orders.types.imaging': 'Bildgebung',
  'visit.orders.types.lab': 'Labor',
  'visit.orders.types.dental_lab': 'Dentallabor',
  'visit.orders.service': 'Leistung',
  'visit.orders.serviceScope': 'Nur Leistungen der Art „{{type}}“',
  'visit.orders.choose': 'Leistung auswählen…',
  'visit.orders.description': 'Beschreibung',
  'visit.orders.descriptionHint': 'Leer lassen, um den Namen der Leistung zu verwenden',
  'visit.orders.notes': 'Hinweise für Labor / Radiologie',
  'visit.orders.urgency': 'Dringlichkeit',
  'visit.orders.urgencies.routine': 'Routine',
  'visit.orders.urgencies.urgent': 'Dringend',
  'visit.orders.urgencies.stat': 'Notfall',
  'visit.orders.sessions': 'Anzahl der Sitzungen',
  'visit.orders.sessionCount': 'Sitzungen: {{count}}',
  'visit.orders.add': 'Anordnung erfassen',
  'visit.orders.statuses.pending': 'Ausstehend',
  'visit.orders.statuses.in_progress': 'In Bearbeitung',
  'visit.orders.statuses.completed': 'Abgeschlossen',
  'visit.orders.statuses.cancelled': 'Annulliert',
  'visit.orders.transitions.start': 'Beginnen',
  'visit.orders.transitions.complete': 'Als erledigt markieren',
  'visit.orders.transitions.cancel': 'Annullieren',
  'visit.orders.suggest': 'KI-Vorschläge',
  'visit.orders.suggesting': 'Wird analysiert…',
  'visit.orders.suggestions': 'Vorgeschlagene Anordnungen',
  'visit.orders.suggestClose': 'Vorschläge ausblenden',
  'visit.orders.suggestAdd': 'Anordnung erfassen',
  'visit.orders.suggestAdded': 'Erfasst',
  'visit.orders.noSuggestions': 'Keine Vorschläge. Erfassen Sie zuerst die Diagnose oder Beurteilung dieser Sitzung – die Analyse stützt sich auf das, was für diese Sitzung dokumentiert wurde.',
  'visit.orders.suggestUnavailable': 'KI-Vorschläge sind nicht verfügbar.',
  'visit.orders.suggestDropped': 'Vorschläge außerhalb des zahnärztlichen Leistungskatalogs, nicht angezeigt: {{count}}',

  // ── §3.2.3 diagnosis, with click-to-reveal traceability ─────────────────
  'visit.diagnosis.error.title': 'Diagnosen konnten nicht geladen werden',
  'visit.diagnosis.error.body': 'Die Diagnosen dieser Sitzung konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.diagnosis.saveFailed': 'Die Diagnose konnte nicht gespeichert werden.',
  'visit.diagnosis.empty.title': 'Keine Diagnose erfasst',
  'visit.diagnosis.empty.description': 'Erfassen Sie Ihre Schlussfolgerung; die Befunde, auf denen sie beruht, werden mit ihr gespeichert.',
  'visit.diagnosis.name': 'Diagnose',
  'visit.diagnosis.code': 'ICD-Code',
  'visit.diagnosis.certainty': 'Diagnosesicherheit',
  'visit.diagnosis.verification.provisional': 'Verdacht',
  'visit.diagnosis.verification.confirmed': 'Gesichert',
  'visit.diagnosis.add': 'Diagnose erfassen',
  'visit.diagnosis.remove': '{{name}} entfernen',
  'visit.diagnosis.willAttach': 'Stützende Befunde, die mit dieser Diagnose gespeichert werden: {{count}}',
  'visit.diagnosis.evidence': 'Belege ({{count}})',
  'visit.diagnosis.noEvidence': 'Zu dieser Diagnose wurden keine stützenden Befunde erfasst.',
  'visit.diagnosis.evidenceKind.subjective': 'Anamnese',
  'visit.diagnosis.evidenceKind.history': 'Vorgeschichte',
  'visit.diagnosis.evidenceKind.chart': 'Zahnschema',
  'visit.diagnosis.evidenceKind.file': 'Dokument',
  'visit.diagnosis.evidenceKind.order': 'Anordnung',
  'visit.diagnosis.evidenceKind.ai': 'KI-Analyse',
  'visit.diagnosis.showTooth': 'Zahn anzeigen',
  'visit.diagnosis.toothEvidence': 'Befunde an Zahn {{fdi}}',
  'visit.diagnosis.aiAssisted': 'KI-gestützt',
  'visit.diagnosis.suggest': 'KI-Vorschläge',
  'visit.diagnosis.suggesting': 'Wird analysiert…',
  'visit.diagnosis.suggestions': 'Vorgeschlagene Diagnosen',
  'visit.diagnosis.noSuggestions': 'Keine Vorschläge. Erfassen Sie zuerst die Anamnese – die Analyse stützt sich auf das, was für diese Sitzung dokumentiert wurde.',
  'visit.diagnosis.suggestUnavailable': 'KI-Vorschläge sind derzeit nicht verfügbar.',
  'visit.diagnosis.accept': 'Erfassen',
  'visit.diagnosis.alreadyRecorded': 'Erfasst',
  'visit.diagnosis.confidence.high': 'Hohe Konfidenz',
  'visit.diagnosis.confidence.medium': 'Mittlere Konfidenz',
  'visit.diagnosis.confidence.low': 'Geringe Konfidenz',

  // ── SOAP assistant — the diagnosis tab ──────────────────────────────────
  'visit.soap.title': 'Dokumentationsassistent',
  'visit.soap.description': 'Schildern Sie, was in der Sitzung geschehen ist; wenn Sie stoppen, ergänzt der Assistent die Abschnitte der Dokumentation und gibt Empfehlungen zum Problem. Nichts wird erfasst, bevor Sie es bestätigen.',
  'visit.soap.speak': 'Sitzung diktieren',
  'visit.soap.speakStop': 'Beenden und Empfehlungen erhalten',
  'visit.soap.analyzing': 'Wird analysiert…',
  'visit.soap.heard': 'Erkannter Text:',
  'visit.soap.retry': 'Erneut senden',
  'visit.soap.voiceUnavailable': 'Das Diktat erfordert ein Mikrofon und eine sichere Verbindung (HTTPS) und ist in diesem Browser nicht verfügbar.',
  'visit.soap.draftTitle': 'Vorgeschlagener Entwurf der Dokumentation',
  'visit.soap.sections.s': 'Anamnese (S) – wird den Notizen angefügt',
  'visit.soap.sections.o': 'Untersuchung und Befund (O)',
  'visit.soap.sections.a': 'Beurteilung (A)',
  'visit.soap.sections.p': 'Plan (P)',
  'visit.soap.apply': 'In die Dokumentation übernehmen',
  'visit.soap.applied': 'In die Dokumentation übernommen.',
  'visit.soap.applyFailed': 'Der Entwurf konnte nicht übernommen werden.',
  'visit.soap.dismiss': 'Verwerfen',
  'visit.soap.noNews': 'Nichts Neues für die Dokumentation.',
  'visit.soap.refineUnavailable': 'Die Vervollständigung der Dokumentation ist nicht verfügbar.',
  'visit.soap.adviceTitle': 'Empfehlungen des Assistenten',
  'visit.soap.adviceUnavailable': 'KI-Empfehlungen sind nicht verfügbar.',
  'visit.soap.suggestedDiagnosis': 'Vorgeschlagene Diagnose',
  'visit.soap.recordDiagnosis': 'Als Diagnose erfassen',
  'visit.soap.accepted': 'Übernommen – in den Diagnosen dieser Sitzung erfasst.',
  'visit.soap.actions': 'Vorgeschlagene Maßnahmen',
  'visit.soap.medications': 'Vorgeschlagene Medikamente',
  'visit.soap.aiEvidence': 'Abgeleitet aus der Analyse der Sitzungsschilderung',

  // ── Per-tooth findings from the narrative → the dental chart ──────────────
  'visit.soap.teeth.title': 'Zahnbefunde',
  'visit.soap.teeth.description': 'Diese Angaben wurden aus der Sitzungsschilderung bestimmten Zähnen zugeordnet. Was Sie bestätigen, wird im Zahnschema erfasst; der Rest wird nicht erfasst.',
  'visit.soap.teeth.lowConfidenceHint': 'Zeilen mit geringer Konfidenz sind nicht vorausgewählt – prüfen Sie die Zahnnummer vor dem Erfassen.',
  'visit.soap.teeth.tooth': 'Zahn {{fdi}}',
  'visit.soap.teeth.surface': 'Fläche {{surface}}',
  'visit.soap.teeth.historical': 'Vorbestehend',
  'visit.soap.teeth.record': 'Im Zahnschema erfassen ({{count}})',
  'visit.soap.teeth.recording': 'Wird erfasst…',
  'visit.soap.teeth.recorded': 'Im Zahnschema erfasst.',
  'visit.soap.teeth.recordFailed': 'Die Befunde konnten nicht im Zahnschema erfasst werden.',
  'visit.soap.teeth.none': 'In der Schilderung wurde kein Befund zu einem bestimmten Zahn gefunden.',
  'visit.soap.teeth.unavailable': 'Das Auslesen von Zahnbefunden ist nicht verfügbar.',
  'visit.soap.teeth.confidence.high': 'Hohe Konfidenz',
  'visit.soap.teeth.confidence.medium': 'Mittlere Konfidenz',
  'visit.soap.teeth.confidence.low': 'Geringe Konfidenz',
  'tooth.aspect.presence': 'Vorhandensein des Zahns',
  'tooth.aspect.condition': 'Zahnzustand',
  'tooth.aspect.surface': 'Zustand der Fläche',
  'tooth.value.sound': 'Gesund',
  'tooth.value.caries': 'Karies',
  'tooth.value.root_canal': 'Wurzelgefüllt',
  'tooth.value.post_core': 'Stiftaufbau',
  'tooth.value.crown': 'Krone',
  'tooth.value.veneer': 'Veneer',
  'tooth.value.implant': 'Implantat',
  'tooth.value.bridge_abutment': 'Brückenpfeiler',
  'tooth.value.bridge_pontic': 'Brückenglied',
  'tooth.value.fracture': 'Fraktur',
  'tooth.value.attrition': 'Attrition',
  'tooth.value.mobility': 'Zahnlockerung',
  'tooth.value.periapical_lesion': 'Apikale Läsion',
  'tooth.value.sealant': 'Fissurenversiegelung',
  'tooth.value.temporary': 'Provisorisch',
  'tooth.value.watch': 'Zu beobachten',
  'tooth.value.restoration': 'Füllung',
  'tooth.value.recurrent_caries': 'Sekundärkaries',
  'tooth.value.fractured': 'Frakturiert',
  'tooth.value.present': 'Vorhanden',
  'tooth.value.extracted': 'Extrahiert',
  'tooth.value.exfoliated': 'Ausgefallen',
  'tooth.value.congenitally_absent': 'Nicht angelegt',
  'tooth.value.unerupted': 'Nicht durchgebrochen',
  'tooth.value.impacted': 'Retiniert',
  'tooth.material.composite': 'Komposit',
  'tooth.material.amalgam': 'Amalgam',
  'tooth.material.glass_ionomer': 'Glasionomerzement',
  'tooth.material.zirconia': 'Zirkonoxid',
  'tooth.material.pfm': 'VMK',
  'tooth.material.full_metal': 'Vollguss (NEM)',
  'tooth.material.emax': 'E.max',
  'tooth.material.temporary': 'Provisorisch',
  'tooth.material.gold': 'Gold',

  // ── §3.2.4 questions — the clinical assistant ───────────────────────────
  'visit.questions.title': 'Klinischer Assistent',
  'visit.questions.forDiagnoses': 'Fragen zur Bestätigung oder zum Ausschluss: {{list}}',
  'visit.questions.noDiagnosesYet': 'Noch keine Diagnose erfasst – der Assistent stellt Fragen zum dokumentierten Vorstellungsgrund.',
  'visit.questions.generate': 'Lücken finden',
  'visit.questions.generating': 'Wird geprüft…',
  'visit.questions.unavailable': 'Der klinische Assistent ist derzeit nicht verfügbar.',
  'visit.questions.fallbackNote': 'Dies sind allgemeine Fragen, nicht speziell für diesen Patienten formuliert.',
  'visit.questions.empty.title': 'Keine offenen Fragen',
  'visit.questions.empty.description': 'Für die aktuellen Diagnosen ist nichts weiter erforderlich.',
  'visit.questions.count': 'Fragen: {{count}}',
  'visit.questions.yes': 'Ja',
  'visit.questions.no': 'Nein',
  'visit.questions.recorded': 'Erfasst: {{statement}}',
  'visit.questions.recordFailed': 'Die Antwort konnte nicht in der Anamnese erfasst werden.',
  'visit.questions.askTitle': 'Assistent fragen',
  'visit.questions.askPlaceholder': 'Frage zu diesem Patienten…',
  'visit.questions.ask': 'Fragen',
  'visit.questions.asking': 'Frage wird gesendet…',
  'visit.questions.followUps': 'Mögliche Anschlussfragen',

  // ── §3.2.5 files, and the report each one produced ──────────────────────

  // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
  'visit.files.kind': 'Was ist das?',
  'visit.files.kinds.image': 'Zahnärztliche Aufnahme',
  'visit.files.kinds.document': 'Dokument',
  'visit.files.viewType': 'Aufnahmeart',
  'visit.files.viewTypes.periapical': 'Zahnfilm',
  'visit.files.viewTypes.bitewing': 'Bissflügelaufnahme',
  'visit.files.viewTypes.panoramic': 'Panoramaaufnahme (OPG)',
  'visit.files.viewTypes.ceph': 'Fernröntgenseitenbild (FRS)',
  'visit.files.viewTypes.photo': 'Foto',
  'visit.files.plainUploadNote': 'Beim Hochladen wird die Datei nur gespeichert. Texterkennung und Bildauswertung sind separate Aktionen.',
  'visit.files.unsupportedImage': 'Dieses Bildformat kann nicht angezeigt werden. Verwenden Sie JPEG oder PNG.',
  'visit.files.openImage': 'Bild öffnen',
  'visit.files.extract': 'Text extrahieren',
  'visit.files.extracting': 'Wird extrahiert…',

  // ── The image workspace ─────────────────────────────────────────────────
  'visit.image.back': 'Zurück zu den Dateien',
  'visit.image.tools': 'Zeichenwerkzeuge',
  'visit.image.tool.cursor': 'Auswählen',
  'visit.image.tool.pin': 'Markierung',
  'visit.image.tool.box': 'Rechteck',
  'visit.image.tool.ellipse': 'Kreis',
  'visit.image.tool.arrow': 'Pfeil',
  'visit.image.tool.freehand': 'Freihand',
  'visit.image.color': 'Stiftfarbe',
  'visit.image.colorName.E11D48': 'Rot',
  'visit.image.colorName.F59E0B': 'Bernstein',
  'visit.image.colorName.0EA5A0': 'Petrol',
  'visit.image.colorName.2563EB': 'Blau',
  'visit.image.zoomIn': 'Vergrößern',
  'visit.image.zoomOut': 'Verkleinern',
  'visit.image.fit': 'Ansicht zurücksetzen',
  'visit.image.brightness': 'Helligkeit',
  'visit.image.contrast': 'Kontrast',
  'visit.image.read': 'Bild auswerten',
  'visit.image.reading': 'Wird ausgewertet…',
  'visit.image.readStatus.no_findings': 'Der Assistent hat in diesem Bild nichts Berichtenswertes gefunden. Es wurde nichts abgebucht.',
  'visit.image.readStatus.no_image': 'Das Bild konnte nicht gelesen werden.',
  'visit.image.comment': 'Notiz zu dieser Markierung',
  'visit.image.commentPlaceholder': 'Was haben Sie hier gesehen?',
  'visit.image.removeMark': 'Diese Markierung löschen',
  'visit.image.tooManyMarks': 'Ein Bild kann höchstens {{max}} Markierungen enthalten.',
  'visit.image.saveFailed': 'Die Markierungen konnten nicht gespeichert werden.',
  'visit.image.unsaved': 'Nicht gespeicherte Markierungen – klicken Sie auf „Speichern“.',
  'visit.image.findings': 'Vom Assistenten erkannt',
  'visit.image.findingsNote': 'Vorschläge. Nichts wird im Zahnschema erfasst, bevor Sie es bestätigen.',
  'visit.image.confidence.high': 'Eindeutig',
  'visit.image.confidence.medium': 'Wahrscheinlich',
  'visit.image.confidence.low': 'Unsicher',
  'visit.image.notLocalized': 'Lage nicht ermittelt',
  'visit.image.unlocalizedNote': 'Befunde, die nicht im Bild verortet werden konnten und nur aufgelistet sind: {{count}}',
  'visit.image.confirm': 'Bestätigen',
  'visit.files.openFile': 'Datei öffnen',
  'visit.image.register': 'Erfassen',
  'visit.image.registering': 'Wird erfasst…',
  'visit.image.notRegistered.title': 'Nicht als zahnärztliche Aufnahme erfasst',
  'visit.image.notRegistered.body': 'Sie können die Datei ansehen. Zum Markieren und zur Auswertung durch den Assistenten ist eine Aufnahmeart erforderlich – eine Bissflügelaufnahme und ein Foto zeigen nicht dasselbe.',
  'visit.image.changeView': 'Aufnahmeart ändern',
  'visit.image.viewType.title': 'Aufnahmeart',
  'visit.image.viewType.body': 'Davon hängt ab, was der Assistent melden darf – eine Bissflügelaufnahme zeigt keine apikale Läsion, und ein Foto zeigt keinen Knochen. Korrigieren Sie die Angabe, falls sie falsch ist.',
  'visit.image.discard.title': 'Gezeichnete Markierungen verwerfen?',
  'visit.image.discard.body': 'Sie wurden nicht gespeichert, und es gibt keine weitere Kopie davon.',
  'visit.image.discard.confirm': 'Verwerfen',
  'visit.files.error.title': 'Dateien konnten nicht geladen werden',
  'visit.files.error.body': 'Die Dokumente dieses Patienten konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
  'visit.files.empty.title': 'Keine Dokumente',
  'visit.files.empty.description': 'Laden Sie eine Röntgenaufnahme, einen Laborbefund oder ein Überweisungsschreiben hoch.',
  'visit.files.upload': 'Dokument hochladen',
  'visit.files.uploading': 'Wird hochgeladen…',
  'visit.files.uploadFailed': 'Das Dokument konnte nicht hochgeladen werden.',
  'visit.files.readFailed': 'Die Datei konnte nicht gelesen werden.',
  'visit.files.tooLarge': 'Die Datei ist größer als 15 MB.',
  'visit.files.docType': 'Dokumenttyp',
  'visit.files.docTypes.lab_report': 'Laborbefund',
  'visit.files.docTypes.prescription': 'Rezept',
  'visit.files.docTypes.general': 'Sonstiges',
  'visit.files.attachTooth': 'Zahn {{fdi}} zuordnen',
  'visit.files.thisVisit': 'Diese Sitzung',
  'visit.files.hasReport': 'Bericht',
  'visit.files.noReport': 'Aus diesem Dokument wurde kein Bericht extrahiert.',
  'visit.files.previewFailed': 'Die Datei konnte nicht geöffnet werden.',
  'visit.files.bytesGone': 'Die Originaldatei ist nicht mehr gespeichert; nur ihr Bericht ist noch vorhanden.',
  'visit.files.remove': '{{name}} löschen',
  'visit.files.units.b': 'B',
  'visit.files.units.kb': 'KB',
  'visit.files.units.mb': 'MB',

  // ── credits (اعتبار) ──────────────────────────────────────────────────────
  'credits.title': 'Parseh-Guthaben',
  'credits.subtitle': 'Ihr Parseh-Guthaben, wofür es verwendet wurde und wie Sie es aufladen.',
  'credits.unit': 'Parseh',
  'credits.toman': 'Toman',
  'credits.tomanShort': 'T',
  'credits.currentBalance': 'Aktuelles Guthaben',
  'credits.buy': 'Parseh kaufen',
  'credits.topUp': 'Aufladen',
  'credits.percent': '{{value}} %',
  'credits.timesUsed': '{{count}}×',
  'credits.itemCount': 'Einträge: {{count}}',
  'credits.minutesUsed': '{{count}} Min.',
  'credits.byService': 'Wofür verwendet',
  'credits.transactions': 'Umsätze',
  'credits.level.low': 'Niedriges Guthaben',
  'credits.level.lowShort': 'Niedrig',
  'credits.level.mid': 'Guthaben wird knapp',
  'credits.level.midShort': 'Mäßig',
  'credits.level.ok': 'Ausreichendes Guthaben',
  'credits.level.okShort': 'Gut',
  'credits.banner.low': 'Nur noch {{coins}} Parseh. Der Assistent stoppt, sobald das Guthaben aufgebraucht ist.',
  'credits.banner.mid': 'Noch {{coins}} Parseh – genug für einige weitere Sitzungen.',
  'credits.service.assistant': 'Klinischer Assistent',
  'credits.service.interaction': 'Wechselwirkungsprüfung',
  'credits.service.transcription': 'Transkription',
  'credits.service.topUp': 'Aufladung',
  'credits.service.gift': 'Geschenkcode',
  'credits.service.sms': 'SMS',
  'credits.service.ai': 'KI-Dienst',
  'credits.filter.label': 'Umsätze filtern',
  'credits.filter.all': 'Alle',
  'credits.filter.spend': 'Abgebucht',
  'credits.filter.topUp': 'Aufgeladen',
  'credits.group.label': 'Gruppieren nach',
  'credits.group.day': 'Tag',
  'credits.group.type': 'Dienst',
  'credits.range.label': 'Zeitraum',
  'credits.range.all': 'Gesamter Zeitraum',
  'credits.range.days7': 'Letzte 7 Tage',
  'credits.range.days30': 'Letzte 30 Tage',
  'credits.range.thisMonth': 'Dieser Monat',
  'credits.time.today': 'Heute',
  'credits.time.yesterday': 'Gestern',
  'credits.kpi.month': 'Verbrauch diesen Monat',
  'credits.kpi.perVisit': 'Pro Sitzung',
  'credits.kpi.topService': 'Größter Posten',
  'credits.showingRange': 'Angezeigt: {{from}}–{{to}} von {{total}}',
  'credits.pager.page': 'Seite {{page}} von {{total}}',
  'credits.pager.previous': 'Zurück',
  'credits.pager.next': 'Weiter',
  'credits.empty.title': 'Noch keine Umsätze',
  'credits.empty.hint': 'Jede Aktion des Assistenten in einer Sitzung erscheint hier.',
  'credits.empty.filtered': 'Keine Umsätze in diesem Zeitraum',
  'credits.empty.filteredHint': 'Wählen Sie einen größeren Zeitraum oder einen anderen Filter.',
  'credits.error.title': 'Umsätze nicht verfügbar',
  'credits.error.body': 'Ihr Guthaben konnte nicht gelesen werden. Es wurde nichts abgebucht.',
  'credits.priceList.title': 'Was jede Aktion kostet',
  'credits.priceList.hint': 'Abgebucht wird nur, wenn Sie die Schaltfläche drücken – nichts startet von selbst.',
  'credits.priceList.viewAll': 'Alle anzeigen',
  'credits.price.transcription': 'Diktat (Spracherkennung)',
  'credits.price.differential': 'KI-Diagnosevorschlag',
  'credits.price.advice': 'Empfehlungen des Assistenten',
  'credits.price.soap': 'Dokumentation vervollständigen',
  'credits.price.teeth': 'Zahnbefunde aus der Sitzungsbeschreibung',
  'credits.price.confirmq': 'Rückfragen zur Bestätigung',
  'credits.price.ask': 'Assistent fragen',
  'credits.price.ocr': 'Hochgeladenes Dokument auslesen',
  'credits.price.interaction': 'Wechselwirkungsprüfung',
  'credits.topUp.chooseAmount': 'Betrag wählen',
  'credits.topUp.recommended': 'Empfohlen',
  'credits.topUp.approxVisits': 'Sitzungen mit dem Assistenten: ca. {{count}}',
  'credits.topUp.custom': 'Anderer Betrag',
  'credits.topUp.customAria': 'Betrag',
  'credits.topUp.payVia': '{{amount}} Toman über {{gateway}} bezahlen',
  'credits.topUp.enterAmount': 'Betrag eingeben',
  'credits.topUp.redirecting': 'Weiterleitung zum Zahlungsanbieter…',
  'credits.topUp.redirectNote': 'Sie werden zum Zahlungsportal der Bank weitergeleitet und anschließend hierher zurückgeführt.',
  'credits.topUp.minimum': 'Der Mindestbetrag beträgt {{amount}} Toman.',
  'credits.topUp.failed': 'Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
  'credits.topUp.failedWithReason': 'Die Zahlung konnte nicht gestartet werden: {{reason}}',
  'credits.gateway.saderat': 'Bank Saderat',
  'credits.gateway.zarinpal': 'Zarinpal',
  'credits.payment.done': 'Zahlung erfolgreich – Ihr Guthaben wurde aufgeladen.',
  'credits.payment.failed': 'Die Zahlung ist nicht zustande gekommen. Es wurde nichts abgebucht.',
  'credits.gift.title': 'Geschenkcode',
  'credits.gift.hint': 'Haben Sie einen Code aus einer Parsina-Aktion? Geben Sie ihn hier ein – der Parseh-Betrag wird Ihrem Guthaben hinzugefügt.',
  'credits.gift.placeholder': 'PARSINA-1404-XXXX',
  'credits.gift.submit': 'Einlösen',
  'credits.gift.submitting': 'Wird eingelöst…',
  'credits.gift.empty': 'Geben Sie zuerst den Code ein.',
  'credits.gift.notFound': 'Dieser Code ist ungültig. Geben Sie ihn genau so ein, wie Sie ihn erhalten haben.',
  'credits.gift.oneUse': 'Jeder Code kann nur einmal verwendet werden.',
  'credits.gift.success': '{{parseh}} Parseh hinzugefügt',
  'credits.gift.successSub': 'Sitzungen mit dem Assistenten: ca. {{visits}}.',
  'credits.gift.newBalance': 'Neues Guthaben',
  'credits.gift.myCodes': 'Ihre Codes',
  'credits.gift.worth': '{{parseh}} Parseh – Sitzungen: ca. {{visits}}',
  'credits.gift.status.issued': 'Unbenutzt',
  'credits.gift.status.redeemed': 'Eingelöst',
  'credits.gift.status.revoked': 'Widerrufen',
  'credits.gift.status.expired': 'Abgelaufen',
  'credits.lowBalance.title': 'Warnung bei niedrigem Guthaben',
  'credits.lowBalance.hint': 'Wir benachrichtigen Sie, wenn Ihr Guthaben unter diesen Wert fällt.',
  'credits.lowBalance.toggleAria': 'Warnungen bei niedrigem Guthaben aktivieren',
  'credits.lowBalance.thresholdAria': 'Warnschwelle in Parseh',
  'credits.lowBalance.active': 'Sie werden gewarnt, wenn Ihr Guthaben unter {{coins}} Parseh fällt.',
  'credits.lowBalance.off': 'Warnungen sind deaktiviert.',
  'credits.lowBalance.invalid': 'Geben Sie einen gültigen Schwellenwert ein.',
  'credits.lowBalance.saved': 'Warneinstellungen gespeichert.',
  'credits.lowBalance.failed': 'Die Warneinstellungen konnten nicht gespeichert werden.',
};
